import PropTypes from 'prop-types';

import { themes } from '../../lib/themes';
import { CloudinaryImage } from '../CloudinaryImage';

/*
 * Temporarily fetches uuid from publicId while the feature flags for UUID
 * avatars is turned OFF on back end (see FF_WBRT_5418_USE_UUID_AVATARS)
 */
const fetchUuidFromPublicId = (publicId) => {
  if (!publicId) return;

  const matches = [...publicId.matchAll(/wb\/assets\/uuid\/([^/^?]+)/g)];
  return matches?.[0]?.[1];
};

export const parseAvatar = (avatar) => {
  const { type, value } = avatar || {};

  let image =
    type === 'uuid'
      ? { uuid: value }
      : type === 'publicId'
        ? { publicId: value }
        : type === 'facebookId'
          ? { facebookId: value }
          : {};

  if (type === 'publicId') {
    const uuid = fetchUuidFromPublicId(image.publicId);
    if (uuid) image = { uuid };
  }

  return image;
};

/**
 * Render the given user avatar. Note that this component
 * expects a User.avatarV2 GraphQL type.
 *
 * @param {object} opts
 * @param {object} opts.avatar
 * @param {'facebookId'|'publicId'} opts.avatar.type
 * @param {string} opts.avatar.value - Either a facebookId or a publicId value.
 * @param {number} opts.size
 * @param {string} opts.shape
 * @param {string} opts.crop
 * @returns {JSX.Element}
 */
function AvatarImage({ avatar, size, shape, crop = 'fill', ...props }) {
  const radiusRatio = shape == 'round' ? 0.5 : 0.125;
  const borderRadius = size * radiusRatio;

  const image = parseAvatar(avatar);

  const extendedProps = {
    ...props,
    image,
    crop,
    height: size,
    width: size,
    style: {
      borderRadius,
      height: size,
      width: size,
    },
  };
  return <CloudinaryImage {...extendedProps} />;
}

AvatarImage.propTypes = {
  theme: PropTypes.oneOf(themes),
  avatarV2: PropTypes.object,
  shape: PropTypes.oneOf(['round', 'square']),
  size: PropTypes.number,
  className: PropTypes.string,
  draggable: PropTypes.bool,
};

AvatarImage.defaultProps = {
  theme: 'waybetter',
  shape: 'square',
  size: 30,
  draggable: false,
};

export default AvatarImage;
